import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
    COMMITMENT_DAYS,
    COMMITMENT_FREQUENCY,
    COMMITMENT_SLOTS,
} from '../../../constants/commitment';
import { normalizeCommitmentDetails } from '../../../utils/commitment';
import './index.scss';

const CommitmentSummary = ({ value, className }) => {
    const { t } = useTranslation();
    const normalized = useMemo(() => normalizeCommitmentDetails(value), [value]);
    const hasSchedule = normalized.schedule.some((day) => Array.isArray(day.slots) && day.slots.length > 0);
    const hasFrequency = Boolean(normalized.frequency);
    const hasNotes = Boolean((normalized.notes || '').trim());

    const dayLabel = (dayId) => {
        const match = COMMITMENT_DAYS.find((entry) => entry.id === dayId);
        return match ? t(match.labelKey) : dayId;
    };

    const slotLabel = (slotId) => {
        const match = COMMITMENT_SLOTS.find((entry) => entry.id === slotId);
        return match ? t(match.labelKey) : slotId;
    };

    const frequencyLabel = (frequencyId) => {
        const match = COMMITMENT_FREQUENCY.find((entry) => entry.id === frequencyId);
        return match ? t(match.labelKey) : frequencyId;
    };

    return (
        <div className={`commitment-display${className ? ` ${className}` : ''}`}>
            {hasSchedule && (
                <div className="commitment-display__block">
                    <h4 className="commitment-subtitle">{t('home.profileSections.commitment.scheduleTitle')}</h4>
                    <div className="commitment-view-list">
                        {normalized.schedule
                            .filter((day) => Array.isArray(day.slots) && day.slots.length > 0)
                            .map((day) => (
                                <div key={day.day} className="commitment-view-row">
                                    <span className="commitment-view-day">{dayLabel(day.day)}</span>
                                    <span className="commitment-view-slots">
                                        {day.slots.map((slotId) => slotLabel(slotId)).join(', ')}
                                    </span>
                                </div>
                            ))}
                    </div>
                </div>
            )}
            {hasFrequency && (
                <div className="commitment-display__block">
                    <h4 className="commitment-subtitle">{t('home.profileSections.commitment.frequencyTitle')}</h4>
                    <p className="commitment-frequency-value">{frequencyLabel(normalized.frequency)}</p>
                </div>
            )}
            {hasNotes && (
                <div className="commitment-display__block">
                    <h4 className="commitment-subtitle">{t('home.profileSections.commitment.notesTitle')}</h4>
                    <p className="commitment-list">{normalized.notes}</p>
                </div>
            )}
            {!hasSchedule && !hasFrequency && !hasNotes && (
                <p className="commitment-list">{t('home.profileSections.commitment.empty')}</p>
            )}
        </div>
    );
};

CommitmentSummary.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    className: PropTypes.string,
};

CommitmentSummary.defaultProps = {
    value: '',
    className: '',
};

export default CommitmentSummary;
